import type { FC } from 'react';
import { JFormMultiselect, type JFormMultiselectProps } from './JFormMultiselect';
import { TagSelect, type TagSelectProps } from './TagSelect';

export interface JFormTagMultiselectProps extends JFormMultiselectProps {
  tagMultiselectProps?: Partial<TagSelectProps>;
}

export const JFormTagMultiselect: FC<JFormTagMultiselectProps> = (props) => (
  <JFormMultiselect {...props}>{(renderProps) => <TagSelect {...renderProps} isMulti {...props.tagMultiselectProps} />}</JFormMultiselect>
);
